import { render, staticRenderFns } from "./LookbookCard.vue?vue&type=template&id=122eb7f4&"
import script from "./LookbookCard.vue?vue&type=script&lang=js&"
export * from "./LookbookCard.vue?vue&type=script&lang=js&"
import style0 from "./LookbookCard.vue?vue&type=style&index=0&id=122eb7f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports